import React from "react";
import { FaEnvelope, FaPhoneAlt, FaFacebookF, FaTwitter, FaYoutube } from "react-icons/fa";
import { useTranslation } from "react-i18next";

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bihar-footer">
      <div className="bihar-footer-grid">
        <div>
          <h3>{t("footer.importantLinks")}</h3>
          <a href="/">{t("footer.assets")}</a>
          <a href="/">{t("footer.schemes")}</a>
          <a href="/">{t("footer.mandiPrice")}</a>
          <a href="/">{t("footer.help")}</a>
          <a href="/">{t("footer.privacyPolicy")}</a>
          <a href="/">{t("footer.accessibilityStatement")}</a>
          <a href="/">{t("footer.siteMap")}</a>
        </div>

        <div>
          <h3>{t("footer.otherImportantLinks")}</h3>
          <a href="/">{t("footer.dbtPortal")}</a>
          <a href="/">{t("footer.seedCertification")}</a>
          <a href="/">{t("footer.bavas")}</a>
          <a href="/">{t("footer.horticulture")}</a>
          <a href="/">{t("footer.kisanCallCentre")}</a>
        </div>

        <div>
          <h3>{t("footer.contactInformation")}</h3>
          <p>{t("footer.agriDeptSupport")}</p>
          <p><FaEnvelope /> <strong>{t("footer.agriDeptEmail")}</strong></p>
          <p>{t("footer.kisanCallCentreTollFree")}</p>
          <p><FaPhoneAlt /> <strong>{t("footer.kisanCallCentreNumber")}</strong></p>
          <h3 className="bihar-follow-title">{t("footer.followUs")}</h3>
          <div className="bihar-socials">
            <span><FaFacebookF /></span>
            <span><FaTwitter /></span>
            <span><FaYoutube /></span>
          </div>
        </div>
      </div>

      <div className="bihar-footer-bottom">
        <span>{t("footer.copyright")}</span>
      </div>
    </footer>
  );
}

